"use client";

import { useMemo, memo } from "react";
import { useCheckoutStore } from "@/store/useCheckoutStore";
import { CHECKOUT_STEPS } from "@/components/screen/start-order/components/Checkout/constants";
import { cn } from "@/lib/utils";

export const ProgressBar = ({ className }: React.ComponentProps<"div">) => {
  const currentStep = useCheckoutStore((store) => store.currentStep);

  const width = useMemo(() => {
    return Math.round((100 / (CHECKOUT_STEPS.length - 1)) * (currentStep - 1));
  }, [currentStep]);

  return <div style={{ width: `${width}%` }} className={cn(className)} />;
};

export default memo(ProgressBar);
